import { Clinician, UserContact } from './clinician';
import { BiologicalSex } from './constants';
import { Order } from './order';
import { IUsername } from './user';

export interface IClinicalSummaryLetter {
  completed_on: string;
  description: string;
  mimetype: string;
  uri: string;
}

export interface RequisitionSubjectDemoGraphics {
  dob: string; // YYYY-MM-DD
  sex: BiologicalSex;
}

export interface RequisitionSubject {
  name: IUsername;
  demographics: RequisitionSubjectDemoGraphics;
  contact_info: UserContact;
}

export interface CaseRequisition {
  individual_id: string;
  name: IUsername;
  orders: Order[];
  requisition_id: string;
  sample_received_at?: string;

  relationship: 'PARENT' | 'SIBLING';
}

export interface Requisition {
  individual_id: string;
  name: IUsername;
  orders: Order[];
  requisition_id: string;
  submitted_at: string;
  updated_at: string;
  clinicians?: Clinician[];
  clinical_summary_letter?: IClinicalSummaryLetter;
  subject?: RequisitionSubject;
  sample_received_at?: string;

  case_requisitions?: CaseRequisition[];
}

export enum InsuranceStatus {
  INSURED = 'INSURED',
  NOT_INSURED = 'NOT_INSURED',
}

export interface IFinancialAssistanceForm {
  first_name: string;
  last_name: string;
  date_of_birth: string;
  requisition_id?: string;
  phone_number: string;
  email: string;
  datetime_signed: string;
  estimated_max_cost: number;
  household_income: number;
  household_size: number;
  insurance_status: InsuranceStatus;
  signature: string;
  tos_consent: boolean;
}

export interface GeneticCounselingRequest {
  requisition_id: string;
  appointment_url?: string;
  appointment_date?: string;
  access_code?: string;
  external_status?: string;
  service_type: 'PRE_TEST_REVIEW_ONLY' | 'PRE_TEST_COUNSELING' | 'POST_TEST_REVIEW_ONLY' | 'POST_TEST_COUNSELING';
  requested_on?: string;
  completed_on?: string;
  dnavisit_order_id?: string;
}
